import type { ImageDefinitionCondition } from 'types/images'

export const isSocialProofMillionsVariant =
  (variant: string): ImageDefinitionCondition =>
  (growthBook) => {
    const gbVariant = growthBook.evalFeature(
      'onboarding_social_proof_millions_variant'
    )?.value
    if (variant === 'default' && !gbVariant) {
      return true
    }
    return gbVariant === variant
  }

export const isBigResultsPitchMockupVariant: ImageDefinitionCondition = (
  growthBook
) => {
  const variant = growthBook.evalFeature(
    'onboarding_big_results_pitch_variant'
  )?.value
  return variant === 'big_results_mockup' || variant === 'real_results_mockup'
}

export const isBigResultsPitchCarouselVariant: ImageDefinitionCondition = (
  growthBook
) => {
  const variant = growthBook.evalFeature(
    'onboarding_big_results_pitch_variant'
  )?.value
  return (
    !variant ||
    variant === 'none' ||
    variant === 'big_results_carousel' ||
    variant === 'real_results_carousel'
  )
}
